/*
 *
 * RegisterGirls actions
 *
 */
import { createAction } from 'redux-saga-actions';
import {
  LOAD_CONSENT_SUCCESS,
  LOAD_CONSENT,
} from './constants';


const registerAction = createAction('app/RegisterGirls/REGISTER_GIRLS');

export function loadConsent() {
  return {
    type: LOAD_CONSENT,
  };
}

export function loadConsentSuccess(response) {
  return {
    type: LOAD_CONSENT_SUCCESS,
    content: response.content,
  };
}
export default registerAction;
